import { render, staticRenderFns } from "./practiceFrom.vue?vue&type=template&id=00c59f4e&scoped=true"
import script from "./practiceFrom.vue?vue&type=script&lang=js"
export * from "./practiceFrom.vue?vue&type=script&lang=js"
import style0 from "./practiceFrom.vue?vue&type=style&index=0&id=00c59f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c59f4e",
  null
  
)

export default component.exports